import 'swiper/swiper.scss';
import '../scss/main.scss';

import AOS from 'aos';
import 'aos/src/sass/aos.scss';

import * as ScrollMagic from 'scrollmagic';
import { gsap } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
ScrollMagicPluginGsap(ScrollMagic, gsap);

import './app/slides';
import './app/scroll';
import './app/about';
import './app/forms';
import './app/company';
import './app/accordion';
import './app/scrollburger';

$(document).ready(function(){
    AOS.init({
      once: true,
      duration: 1000,
    });

    //Запрет переносов по странице ссылок и картинок
    $("img,a").on("dragstart", function(event){ event.preventDefault();});

    // $(".megamenu__header").click(function() {
    //     $(".header-megamenu__nav-js").toggleClass("active");
    // });


    $('.megamenu__header').click(function (evt) {
		$('.megamenu').toggleClass('megamenu__active');
        $('.megamenu__header').toggleClass('megamenu__active');
        $('.centerlayer').toggleClass('fixed');
	});

    
    $(".slidetoggle .head-toggle").click(function() {
        let parentMenu = $(this).parent();
        parentMenu.toggleClass("active");
        parentMenu.find(".txt-toggle").slideToggle();
    });

    /* map */
    const map = document.querySelector('.map');
    document.body.addEventListener('click', (e) => {
        if(e.target.closest('.map') && !e.target.closest('.map__form-form') && !map.classList.contains('map--hidden-form')) {
            map.classList.add('map--hidden-form');
        }
        if(e.target.closest('.map__button')) {
            map.classList.remove('map--hidden-form');
        }
    });

    if(document.querySelector('.page-btn_up')) {
        document.querySelector('.page-btn_up').addEventListener('click', (e) => {
            document.querySelector('.centerlayer').scrollIntoView({
                behavior: 'smooth'
            });
        });
    }

    $(".toggle-item__first").click(function() {
        $(".toggle__text_first").text(function(i,v) {
            return v === 'Темный фон' ? 'Светлый фон' : 'Темный фон'
        })

        $(".theme__toggle_first").toggleClass("theme__white").removeClass(".theme__dark");
        $("theme__white").addClass(".download__link_light");
        $(".theme__dark").addClass(".download__link_dark");
        $(".theme__toggle_first").toggleClass("theme__color_dark").removeClass(".theme__color_light");
        $(".toggle__title_first").text(function(i,t) {
            return t === 'На темном фоне' ? 'На светлом фоне' : 'На темном фоне'
        })
    });

    $(".toggle-item__second").click(function() {
        $(".toggle__text_second").text(function(i,v) {
            return v === 'Темный фон' ? 'Светлый фон' : 'Темный фон'
        })
        $(".theme__toggle_second").toggleClass("theme__white").removeClass(".theme__dark");
        $(".theme__toggle_second").toggleClass("theme__color_dark").removeClass(".theme__color_light");
        $(".toggle__title_second").text(function(i,t) {
            return t === 'Логотип на темном фоне' ? 'Логотип на светлом фоне' : 'Логотип на темном фоне'
        })
    });

    $(".toggle-item__third").click(function() {
        $(".toggle__text_third").text(function(i,v) {
            return v === 'Темный фон' ? 'Светлый фон' : 'Темный фон'
        })

        $(".theme__toggle_third").toggleClass("theme__white").removeClass(".theme__dark");
        $("theme__white").addClass(".download__link_light");
        $(".theme__dark").addClass(".download__link_dark");
        $(".theme__toggle_third").toggleClass("theme__color_dark").removeClass(".theme__color_light");
        $(".toggle__title_third").text(function(i,t) {
            return t === 'На темном фоне' ? 'На светлом фоне' : 'На темном фоне'
        })
    });



    $(".theme__en").on("click", function () {
        $(this).addClass('theme__active');
        $(".theme__ru").removeClass('theme__active');
       
        $(".icon__toggle_en").show(300);
        $(".icon__toggle_ru").hide(300);

 
        $(".download__link_en_dark").show(); 
        $(".download__link_ru_dark").hide();  
        
        
        $(".download__link_en_light").show(); 
        $(".download__link_ru_light").hide();  
    });
    
    
    $(".theme__ru").on("click", function () {
        $(this).addClass('theme__active');
        $(".theme__en").removeClass('theme__active');
      
        $(".icon__toggle_ru").show(300);
        $(".icon__toggle_en").hide(300);

        $(".download__link_ru_dark").show(); 
        $(".download__link_en_dark").hide();  

        $(".download__link_ru_light").show(); 
        $(".download__link_en_light").hide();     
    });
    

    /* scrollmagic */
    var controller = new ScrollMagic.Controller();
    if(document.querySelector('#trigger1')) {
        var scene = new ScrollMagic.Scene({
            triggerElement: "#trigger1",
            duration : 40,
            //offset: 100
            //triggerHook: 0.5
        }) 
        scene.setTween("#animate1", 0.2, {backgroundColor: "transparent",scale: 2.8})
        //scene.setTween("#animate1", 0.5, {backgroundColor: "transparent",})
        // trigger a TweenMax.to tween
        //.addIndicators({name: "1 (duration: 0)"})
        scene.setPin('#animate1')
        scene.addTo(controller);
    }

    /* video */
    let videoItem;
    document.querySelectorAll('.video').forEach(video => {
      videoItem = video.querySelector('.video__item');
      video.querySelector('.video__inner').addEventListener('click', (e) => {
        if (videoItem.paused) {
          videoItem.play();
          e.target.closest('.video').querySelector('.video__btncontrol').classList.add('invisible');
        } else {
          videoItem.pause();
          e.target.closest('.video').querySelector('.video__btncontrol').classList.remove('invisible');
        }
      });
    });
});